module.exports = __webpack_public_path__ + "img/desktop/Background-freespins/backgroundfs_illuminated@1x.jpg?0.0.53";